import {
  MONUMPAY_WITHDRAWAL,
  MONUMPAY_WITHDRAWAL_SUCCESS,
  MONUMPAY_WITHDRAWAL_FAILURE,
} from "../actionTypes";

export const momumpayPayout = (payload) => ({
  type: MONUMPAY_WITHDRAWAL,
  payload,
});

export const momumpayPayoutSuccess = (payload) => ({
  type: MONUMPAY_WITHDRAWAL_SUCCESS,
  payload,
});

export const momumpayPayoutFailure = () => ({
  type: MONUMPAY_WITHDRAWAL_FAILURE,
});
